/* eslint-disable @typescript-eslint/no-explicit-any */
import { Accordion, AccordionItem, Button, Text } from '@alefeducation/ui-elements-library-core'
import { Times } from '@alefeducation/ui-elements-library-icons'
import React, { useEffect, useState } from 'react'
import { StyledFilterPanel } from './components.styled'
import CheckboxTemplate from './componentsTemplates/CheckboxTemplate'
import DatePickerTemplate from './componentsTemplates/DatePickerTemplate'
import TextInputTemplate from './componentsTemplates/TextInputTemplate'
import UsersSelectorTemplate from './componentsTemplates/UserSelectorTemplate'
import { GenericOnChangeProps, CommonFields, TemplateType } from './types'
import { resetAll } from './utils'

type ContentList = {
  title: string
  key: string
} & TemplateType[keyof TemplateType]

export type AdvancedFilterProps = {
  onClose: () => void
  content: ContentList[]
  onUpdate: (content: ContentList[]) => void
}

const Components: Record<keyof TemplateType, React.ReactNode> = {
  checkbox: CheckboxTemplate,
  text: TextInputTemplate,
  datePicker: DatePickerTemplate,
  usersSelector: UsersSelectorTemplate
}

const renderComponents = (config: ContentList, onChange: GenericOnChangeProps<CommonFields>) => {
  if (typeof Components[config.type] !== 'undefined') {
    return (
      config &&
      config.content &&
      config.content.map((c, i) => {
        return React.createElement(Components[config.type] as React.FC, {
          ...c,
          value: c.value,
          name: config.key,
          index: i,
          onChange: onChange
        })
      })
    )
  }
  return React.createElement(() => <div>Can not find {config.type} component</div>)
}

const AdvancedFilter = ({ content, onClose, onUpdate }: AdvancedFilterProps) => {
  const [state, setState] = useState<ContentList[]>(content)

  useEffect(() => {
    setState(content)
  }, [content])

  const genericOnChange: GenericOnChangeProps<any> = obj => {
    // check if the state exists
    const currentState = state
    const currentObj = state.findIndex(f => f.key === obj.name)
    if (currentObj !== undefined) {
      currentState[currentObj].content[obj.index] = obj
      setState([...currentState])
    }
  }

  const clearAll = () => {
    const afterResetState = resetAll(state)
    setState([...afterResetState])
    onUpdate([...afterResetState])
  }

  return (
    <StyledFilterPanel data-testid="advance-filter-panel">
      <div className="header">
        <Text variant="body-large" weight="bold">
          Filters
        </Text>
        <Times data-testid="advance-filter-close-icon" onClick={onClose} color="primary.40" />
      </div>
      <div className="panel">
        <Accordion allowMultiple data-testid="advance-filter-panel-accordion">
          {state &&
            state.map(l => {
              return (
                <AccordionItem id={l.key} data-testid={`${l.key}-item-test-id`} noBgColor key={l.key} noBorder margin="0" title={l.title}>
                  <div data-testid={`accordion-panel-${l.type}-item`} className="panel-item">
                    {renderComponents(l, genericOnChange)}
                  </div>
                </AccordionItem>
              )
            })}
        </Accordion>
      </div>
      <div className="footer">
        <Button
          variant="ghost"
          data-testid="advance-filter-clear-all"
          onClick={() => {
            clearAll()
          }}
        >
          Clear all
        </Button>
        <Button
          variant="secondary"
          data-testid="advance-filter-cancel"
          onClick={() => {
            onClose()
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          data-testid="advance-filter-apply"
          onClick={() => {
            onUpdate(state)
          }}
        >
          Apply
        </Button>
      </div>
    </StyledFilterPanel>
  )
}

export default AdvancedFilter
